<template>
  <div style="width:100%;height:100%;" ref="pie"></div>
</template>

<script>
import echarts from "echarts";

function setOption(data) {
  var option = {
    backgroundColor: "#fff",
    title: {
      text: data.title ? data.title : "",
      //subtext: data.title.name,
      left: data.legendOrient == "horizontal" ? "0%" : "40%",
      top: "1%",
      textStyle: {
        fontSize: 16,
        color: "#32b6d3",
        fontWeight: "normal",
        fontFamily: "Microsoft YaHei",
        textAlign: "center"
      },
      textAlign: "center"
    },
    grid: {
      left: "0%", //grid 组件离容器左侧的距离。
      right: "5%", //grid 组件离容器右侧的距离。
      top: "0%",
      bottom: "2%", //grid 组件离容器下侧的距离。
      containLabel: true //grid 区域是否包含坐标轴的刻度标签[ default: false ]
    },

    tooltip: {
      show: true,
      confine: true,
      trigger: "item",
      formatter: "{b}: {c} ({d}%)"
    },
    legend: {
      show: data.legendShow == false ? false : true,
      type: "scroll",
      // orient: 'horizontal',
      orient: data.legendOrient ? data.legendOrient : "vertical",
      left: data.legendLeft ? data.legendLeft : "68%",
      top: data.legendTop ? data.legendTop : "25%",
      itemGap: data.legendItemGap ? data.legendItemGap : 10,
      itemWidth: data.legendItemWidth ? data.legendItemWidth : 10,
      itemHeight: data.legendItemHeight ? data.legendItemHeight : 12,
      padding: 12,
      // bottom: '0%',
      data: data.legend
    },
    graphic: data.showGraphic
      ? [
          {
            type: "group",
            top: "middle",
            left: "10%",
            height: 100,
            children: [
              {
                type: "text",
                left: "center",
                top: "30%",
                style: {
                  text: data.total,
                  textAlign: "center",
                  fill: "#0a97b0",
                  font: "24px Microsoft YaHei"
                }
              },
              {
                type: "text",
                left: "center",
                top: "60%",
                style: {
                  text: data.graphicText ? data.graphicText : "总数",
                  textAlign: "center",
                  fill: "#566c77",
                  font: "14px Microsoft YaHei"
                }
              }
            ]
          }
        ]
      : [],
    series: [
      {
        type: "pie",
        selectedMode: "false",
        selectedOffset: 0,
        radius: data.radius ? data.radius : [0, "70%"],
        center: data.center ? data.center : ["40%", "56%"],
        color: data.colorList ? data.colorList : [],
        itemStyle: {
          borderWidth: 0,
          borderColor: "#fff"
          //	shadowColor:"#ccffff",
          //	shadowBlur:'15'
        },
        minAngle: 5,
        label: {
          normal: {
            position: data.labelPosition ? data.labelPosition : "outside",
            // formatter: '{d}%',
            formatter: function(params) {
              if (data.labelPosition == "outside") {
                return params.name + " " + params.value;
              } else {
                // if(params.value == 0){
                // 	return "";
                // }
                return params.value;
              }
            },
            textStyle: {
              color: "#57617B",
              fontSize: 12,
              fontFamily: "Microsoft YaHei"
            }
            // alignTo:"labelLine"
          }
        },
        labelLine: {
          normal: {
            show: true,
            smooth: false,
            length: data.labelLineLength ? data.labelLineLength : 10,
            length2: 10,
            lineStyle: {
              width: 2
            }
          }
        },
        data: data.data
      }
    ]
  };
  return option;
}
export default {
  name: "DgCsPie",
  props: ["args"],
  methods: {
    initChart() {
      window.addEventListener(
        "resize",
        function() {
          this.myChart.resize();
        }.bind(this)
      );
    },
    resize: function() {
      this.myChart.resize();
    },
    reDrawChart: function(args) {
      this.myChart.setOption(setOption(args), false);
      this.myChart.hideLoading();
    }
  },
  mounted: function(el) {
    var container = this.$el;
    this.initChart();
    this.myChart = echarts.init(container);
    let _this = this;
    this.myChart.on("click", function(param) {
      _this.$emit("pieClick", param.data.name);
    });
    this.myChart.showLoading({
      text: "数据正在加载...",
      textStyle: {
        fontSize: 16,
        color: "#444"
      },
      effectOption: { backgroundColor: "rgba(0,0,0,0)" }
    });
  },
  watch: {
    updateFlag: function(val) {
      setTimeout(() => {
        this.myChart.resize();
      }, 150);
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/echarts/dgPieChart.vue